import React from 'react';
import PropTypes from 'prop-types';
import BEMHelper from '@ynap/bem-helper';

const bem = new BEMHelper('Button');

const buttonTypes = ['primary', 'primary-icon', 'primary-link', 'secondary', 'secondary-icon', 'tertiary', 'tertiary-icon', 'applepay'];

const propTypes = {
    component: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
    className: PropTypes.string,
    type: PropTypes.oneOf(buttonTypes),
    children: PropTypes.node,
};

const defaultProps = {
    component: 'button',
};

function Button({ children, className, component: Component, type, ...rest }) {
    return (
        <Component className={bem(null, type, className)} {...rest}>
            {children}
        </Component>
    );
}

Button.propTypes = propTypes;
Button.defaultProps = defaultProps;

// Exported after definition because we were getting undefined values while executing the unit tests
export { buttonTypes };
export default Button;
